import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWpInstanceStatus } from '../store/slices/wpConfigSlice';

const WpStatusPoller = () => {
  const dispatch = useDispatch();
  const { isLogged, token } = useSelector((state) => state.auth);
  const selectedBranch = useSelector((state) => state.branches.selectedBranch);
  const selectedPlace = useSelector((state) => state.branches.selectedPlace);

  useEffect(() => {
    if (!isLogged || !token || !selectedBranch?.id) return;

    // İlk yüklemede kontrol et
    dispatch(fetchWpInstanceStatus({ branchId: selectedBranch.id, placeId: selectedPlace?.id }));

    const intervalId = setInterval(() => {
      dispatch(fetchWpInstanceStatus({ branchId: selectedBranch.id, placeId: selectedPlace?.id }));
    }, 60000); // 60s

    return () => clearInterval(intervalId);
  }, [dispatch, isLogged, token, selectedBranch?.id]);

  return null;
};

export default WpStatusPoller; 